<app-page [title]="notice?.title || 'Notice Details'">
    <div body class="p-6 bg-white shadow-md rounded-lg">
        <!-- Render message content as HTML -->
        <!-- <div class="prose max-w-full" [innerHTML]="notice?.message"></div> -->
        <!-- Render message content -->
        <div class="prose max-w-full">
            <ng-container *ngIf="notice?.parsedMessage?.type === 'image'; else textContent">
                <img [src]="notice?.parsedMessage?.value" alt="Notice Image" class="max-w-full h-auto rounded shadow" />
            </ng-container>
        
            <ng-template #textContent>
                <div [innerHTML]="notice?.parsedMessage?.value"></div>
            </ng-template>
        </div>
  

        <!-- Footer with Expiring Date -->
        <div class="flex justify-between items-center pt-6">
            <small class="text-gray-500 italic">{{ notice?.expiringDate }}</small>
            <button pButton type="button" label="Close" class="p-button-secondary p-button-outlined"
                (click)="goBack()"></button>
        </div>
    </div>
</app-page>